import React from "react";
import { Route } from "react-router-dom";
import Header from "./MainHeader";

function RouteWithHeader({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => (
        <Header>
          <Component {...props} />
        </Header>
      )}
    />
  );
}

export default RouteWithHeader;
